<template>
  <v-row class="d-flex" justify="end" dense v-if="editor">

    <base-button icon="format-bold" :name="$t('bold')" @click="editor.chain().focus().toggleBold().run()"
                 :active="editor.isActive('bold')"/>

    <base-button icon="format-italic" :name="$t('italic')" @click="editor.chain().focus().toggleItalic().run()"
                 :active="editor.isActive('italic')"/>

    <base-button icon="format-strikethrough" :name="$t('strike')" @click="editor.chain().focus().toggleStrike().run()"
                 :active="editor.isActive('strike')"/>


    <table-button :editor="editor" :active="editor.isActive('strike')"/>


    <base-button icon="format-list-bulleted" :name="$t('bulletList')" @click="editor.chain().focus().toggleBulletList().run()"
                 :active="editor.isActive('bulletList')"
    />

    <base-button icon="format-list-numbered" :name="$t('orderedList')" @click="editor.chain().focus().toggleOrderedList().run()"
                 :active="editor.isActive('orderedList')"
    />

    <base-button icon="format-list-checkbox" :name="$t('taskList')" @click="editor.chain().focus().toggleTaskList().run()"
                 :active="editor.isActive('taskList')"
    />

    <base-button icon="code-tags" :name="$t('code')" @click="editor.chain().focus().toggleCode().run()"
                 :active="editor.isActive('code')"
    />

    <base-button icon="format-quote-close" name="Blockquote" @click="editor.chain().focus().toggleBlockquote().run()"
                 :active="editor.isActive('blockquote')"
    />

    <base-button icon="format-quote-close" name="Link" @click="editor.chain()
        .focus()
        .extendMarkRange('link')
        .setLink({ href: 'www.tecna.pl' })
        .run()"
                 :active="editor.isActive('blockquote')"
    />


  </v-row>
</template>

<script>
import BaseButton from "./Buttons/BaseButton";
import TableButton from "./Buttons/TableButton.vue";

export default {
  components: {TableButton, BaseButton},
  props: {
    editor: Object,
  }
}
</script>

<i18n lang="i18n">
{
  "en": {
    "bold": "Bold",
    "italic": "Italic",
    "strike": "Strike",
    "bulletList": "Bullet List",
    "orderedList": "Ordered List",
    "taskList": "Task List",
    "code": "Code"
  },
  "pl": {
    "bold": "Pogrubienie",
    "italic": "Kursywa",
    "strike": "Przekreślenie",
    "bulletList": "Lista punktowana",
    "orderedList": "Lista numerowana",
    "taskList": "Lista zadań",
    "code": "Fragment kodu"
  }
}
</i18n>
